import apiV2 from '../api/v2';
import type { Manufacturer } from '../utils/manufacturer';

// Mirrors the `ManufacturerStatus` interface in
// backend/src/routes/api/v2/patients/workflow/design/manufacturer.status.service.ts.
// Keep in sync by hand.
export interface ManufacturerStatus {
    /** Canonical slug; null when the Aligner Preference is blank or unrecognised. */
    manufacturer: Manufacturer | null;
    manufacturerLabel: string | null;
    accountConfigured: boolean;
    /** We hold an API client for this manufacturer at all — false for Invisalign. */
    automationSupported: boolean;
    /** Supported, configured, and a usable token exists — the guided wizard can run. */
    automationReady: boolean;
}

/** Step 0 - gates the guided wizard vs. the manual submission flow. Manufacturer-neutral endpoint. */
export async function getManufacturerStatus(patientId: string): Promise<ManufacturerStatus> {
    const response = await apiV2.get<{ success: boolean; data: ManufacturerStatus }>(
        `/patients/${patientId}/workflow/design/manufacturer/status`
    );
    return response.data.data;
}
